<template> 
  <modal v-model="show"
         content-class="min-width-400"
         :has-padding="false"> 
   
    <div>
      <div class="card-body">
        <h1 class="text-center"
            v-if="user">{{user.nome}}</h1>

        <h4>
          {{$t('message.users.message.linkSpots')}}
        </h4>

        <vue-nestable v-model="list"
                      :maxDepth="0"
                      keyProp="localTreeId">

          <div class="item"
               slot-scope="{ item }">
            <LocalListItem :node="item"
                           @setChildren="setChildren"
                           @toogle="toggleNode"
                           @setIsOpen="setIsOpenArray" />
          </div>

          <div slot="placeholder"></div>
        </vue-nestable>

        <infinite-loading :identifier="infiniteId"
                          @infinite="load">
          <div slot="no-results">{{$t('message.generics.message.noResultsFound')}}</div>
          <div slot="no-more"></div>
        </infinite-loading>
      </div>

    </div>
  </modal>  
</template>

<script>
    import InfiniteLoading from 'vue-infinite-loading';
    import { VueNestable } from 'vue-nestable'
    import LocalListItem from '@views/users/components/LocalListItem.vue';
    import EventBus from '@packages/event-bus'
    import Modal from "@/components/generic/Modal";

    export default {
        components: {
            VueNestable,
            LocalListItem,
            Modal,
            InfiniteLoading,

        },

        data() {
            return {
                show: false,
                list: [],
                page: 0,
                infiniteId: +new Date(),
                search: '',
                searchTimeout: undefined,
                isOpenArray: []
            }
        },

        props: {
            user: {
                type: Object
            }
        },

        methods: {
          setIsOpenArray({ id, isOpen }) {
            if(isOpen) {
              const hasItem = this.isOpenArray.find((nodeId) => {
                return id === nodeId;
              })

              if(!hasItem) {
                this.isOpenArray.push(id)
              }
            } else {
              this.isOpenArray.filter((nodeId) => {
                return nodeId === id;
              })
            }
          },
          emitOpenEvents() {
            this.isOpenArray.forEach((id) => {
              setTimeout(() => {
                  EventBus.$emit('OPEN_NODE', id)
                }, 200)
            })
          },
          async toggleNode(node) {
              EventBus.$emit('SHOW_SPINNER')

              try {
                await this.$api.localPermissions.assignNode({
                  id: this.user.id,
                  nodeId: node.objectId,
                  type: node.type
                })

                this.reloadList();


              } catch (error) {
                console.log(error)

              } finally {
                setTimeout(() => {
                  this.emitOpenEvents();

                  EventBus.$emit('CANCEL_SPINNER')

                }, 500)
              }
          },
            async reloadList() {
                this.page = 0;
                this.list = [];

                this.infiniteId++;
            },
          async load($state) {
              try {
                this.list = await this.fetch()

                if($state) {
                  $state.loaded();
                  $state.complete();
                }

              } catch (error) {
                console.log(error);
              }

          },
          async fetch() {
            return this.$api.localPermissions.subAccountSearch({
                  id: this.user.id,
                  page: this.page,
                  filter: this.search
            });
          },
          async edit(){
            this.reloadList();

            this.show = true;
          },
          setChildren({ id, value }) {
            const path = this.getPathByIdentifier(id);

            let item = this.list[path[0]];
            for (let index = 1; index < path.length; index++) {
              item = item.children[path[index]];
            }

            if(item) {
              item.children = value;
            }

          },
          getPathByIdentifier(id, items = this.list) {
            let path = []

            items.every((item, i) => {
              if (item['localTreeId'] === id) {
                path.push(i)
              } else if (item.children) {
                const childrenPath = this.getPathByIdentifier(id, item.children)

                if (childrenPath.length) {
                  path = path.concat(i).concat(childrenPath)
                }
              }

              return path.length === 0
            })

            return path
            },
        },
    }
</script>

<style lang="scss" scoped>
.card-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 15px;

  .btn {
    margin: 15px;
  }
}

.card-body {
  padding: 0 40px;

  h4 {
    font-weight: 600;
    color: #b3b3b3;
  }
}

.search {
  margin-bottom: 20px !important;
}

.item {
  display: flex;
  align-items: center;

  .v-input {
    flex: 0;
  }

  p {
    margin: 0;
  }
}
</style>
